var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24999 5.88916L0.185558 1.24409C-0.0872035 0.932367 -0.0556159 0.458544 0.256112 0.185783C0.567839 -0.0869782 1.04166 -0.0553901 1.31442 0.256337L4.24999 3.61127L7.18556 0.256338C7.45832 -0.0553895 7.93214 -0.0869775 8.24387 0.185784C8.5556 0.458545 8.58718 0.932367 8.31442 1.24409L4.24999 5.88916Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalArrowWhite);
export default __webpack_public_path__ + "static/media/modal-arrow-white.c25ee84f6e245527786a5e8ab8b3af7f.svg";
export { ForwardRef as ReactComponent };